import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'chameleon/packages/blue-book-player/library/modal';
import cn from 'classnames';

const BaseModal = ({
  dialogClassName,
  wrapperClassName,
  contentClassName,
  headingClassName,
  topBarClassName,
  closeButtonClassName,
  children,
  title,
  subTitle,
  topBar,
  size,
  onClose,
  showCloseButton,
  showDialogCloseButton,
  contentLabel,
  aria,
  contentWithSpacing = false,
  isContainingBlock,
  isScrollableContent,
  hasTitleWithTooltip,
  closeOnBackgroundClick = true,
  returnFocus = true,
  bottomContent,
}) =>
  ReactDOM.createPortal(
    <Modal
      title={title}
      subTitle={subTitle}
      onClose={onClose}
      topBar={topBar}
      size={size}
      dialogClassName={cn(
        dialogClassName,
        'w-full bb-desktop:h-screen bg-bluebook-gray-900 bg-opacity-90',
      )}
      wrapperClassName={cn(
        wrapperClassName,
        'p-[24px] bb-desktop:rounded-[8px]',
      )}
      contentClassName={cn(contentClassName, 'mb-[24px]')}
      headingClassName={cn(
        headingClassName,
        'mb-[24px] mr-0 ml-0 mt-0 !text-[24px] text-bluebook-gray-900 font-normal !leading-[32px]',
      )}
      topBarClassName={cn(topBarClassName, '!items-start h-12.6 mb-4')}
      closeButtonClassName={cn(closeButtonClassName, 'pr-0')}
      showCloseButton={showCloseButton}
      showDialogCloseButton={showDialogCloseButton}
      contentLabel={contentLabel}
      aria={aria}
      contentWithSpacing={contentWithSpacing}
      isContainingBlock={isContainingBlock}
      isScrollableContent={isScrollableContent}
      hasTitleWithTooltip={hasTitleWithTooltip}
      closeOnBackgroundClick={closeOnBackgroundClick}
      returnFocus={returnFocus}
      bottomContent={bottomContent}
    >
      {children}
    </Modal>,
    document.querySelector('#modal'),
  );

export default BaseModal;
